import supabase from '../supabase/supabase';

/**
 * Loads the public live status for a secret tracking link.
 * Returns null when the link does not match any order.
 */
export async function trackOrderByToken(token) {
  const { data, error } = await supabase.rpc('zevi_track_order_20260925', {
    input_token: token
  });

  if (error) {
    throw new Error('Order tracking is temporarily unavailable.');
  }

  return data || null;
}